import React from 'react';
import { RED } from '../const';

const SVG = ({ style = {}, count, color, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={color} strokeWidth={8} />
      <text fill={color} x="50" y="68" textAnchor="middle" fontSize="48" fontWeight="bold" fontFamily="Roboto Mono">
        {count}
      </text>
    </g>
  </svg>
);

export default SVG;
